import { useState } from "react";
import { connect } from "react-redux";
import { Form, DropdownButton, Dropdown } from "react-bootstrap";

function GroupSelector({
  value = 0,
  onChange,
  groups = [],
  selGroupSlug = null,
}) {
  const [groupFilter, setGroupFilter] = useState("");

  const textValue = () => {
    if (value) {
      const group = groups.find(
        ({ groupId, groupSlug }) =>
          groupId === parseInt(value) || groupSlug === value,
      );

      if (group) {
        return group.groupName;
      }
    }

    return "All Groups";
  };

  const onClick = (group) => {
    if (onChange) {
      if (group) {
        onChange(group.groupId, group.groupSlug);
      } else {
        onChange(0, "");
      }
    }
  };

  return (
    <div className="standard-dropdown">
      <div className="standard-dropdown-label">Group:</div>
      <DropdownButton title={textValue()}>
        <Form.Group className="custom-dropdown-search">
          <Form.Control
            name="group-dropdown-search"
            placeholder="Enter group name"
            onChange={({ target }) => setGroupFilter(target.value)}
            value={groupFilter}
          />
        </Form.Group>
        {groupFilter ? (
          <>
            {groups
              .filter(
                (item) =>
                  item.groupName
                    .toUpperCase()
                    .indexOf(groupFilter.toUpperCase()) > -1,
              )
              .map((group) => (
                <Dropdown.Item
                  key={group.groupId}
                  onClick={() => onClick(group)}
                  as="button"
                >
                  {group.groupName}
                </Dropdown.Item>
              ))}
          </>
        ) : (
          <>
            <Dropdown.Item onClick={() => onClick(null)} as="button">
              All Groups
            </Dropdown.Item>
            {groups.map((group) => (
              <Dropdown.Item
                key={group.groupId}
                onClick={() => onClick(group)}
                as="button"
              >
                {group.groupName}
              </Dropdown.Item>
            ))}
          </>
        )}
      </DropdownButton>
    </div>
  );
}

const mapStateToProps = (state) => ({
  groups: state.networks.groupsList,
});

export default connect(mapStateToProps, {})(GroupSelector);
